import { PropsWithChildren } from 'react';

export const CameraIcon = (props: PropsWithChildren) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M14.7291 7.60813L13.8887 5.0769H8.11156L7.27124 7.60813H4.96036C4.12004 7.60813 3.38477 8.31688 3.38477 9.12687V15.4043C3.38477 16.2143 4.12004 16.9231 4.96036 16.9231H17.0399C17.8803 16.9231 18.6155 16.2143 18.6155 15.4043V9.12687C18.6155 8.31688 17.8803 7.60813 17.0399 7.60813H14.7291Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9999 14.3845C11.6731 14.3845 12.3188 14.1171 12.7949 13.641C13.2709 13.165 13.5383 12.5193 13.5383 11.8461C13.5383 11.1728 13.2709 10.5272 12.7949 10.0511C12.3188 9.57506 11.6731 9.30762 10.9999 9.30762C10.3266 9.30762 9.68098 9.57506 9.20492 10.0511C8.72887 10.5272 8.46143 11.1728 8.46143 11.8461C8.46143 12.5193 8.72887 13.165 9.20492 13.641C9.68098 14.1171 10.3266 14.3845 10.9999 14.3845Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
